
import { useState } from 'react';
import { Link } from 'react-router-dom';

const CatalogPage = () => {
  const [activeCategory, setActiveCategory] = useState('camisas');

  const categories = [
    { id: 'camisas', name: 'Camisas', icon: 'ri-shirt-line' },
    { id: 'bermudas', name: 'Bermudas', icon: 'ri-shorts-line' },
    { id: 'conjuntos', name: 'Conjuntos', icon: 'ri-handbag-line' },
    { id: 'relogios', name: 'Relógios', icon: 'ri-time-line' },
    { id: 'bags', name: 'Bags', icon: 'ri-briefcase-line' },
    { id: 'acessorios', name: 'Acessórios', icon: 'ri-glasses-line' }
  ];

  const products = {
    camisas: [
      {
        id: 1,
        name: 'Camisa Prada Premium',
        brand: 'Prada',
        line: '1.1',
        code: 'PRA001',
        image: 'https://public.readdy.ai/ai/img_res/5025db9139fcae7234ace18b4ada760f.jpg',
        description: 'Camisa Prada 1.1 – tecido italiano, corte slim e acabamento invisível.',
        prices: {
          single: 'R$ 89',
          three: 'R$ 79',
          six: 'R$ 69',
          twelve: 'R$ 59',
          wholesale: 'R$ 49'
        }
      },
      {
        id: 2,
        name: 'Camisa Gucci Italiana',
        brand: 'Gucci',
        line: '1.2',
        code: 'GUC002',
        image: 'https://readdy.ai/api/search-image?query=luxury%20white%20Gucci%20dress%20shirt%20on%20tattooed%20male%20model%2C%20premium%20Italian%20cotton%20fabric%20texture%20close-up%2C%20elegant%20studio%20setup%20with%20fabric%20weave%20details%2C%20clean%20white%20background%20with%20professional%20lighting%2C%20high-end%20menswear%20photography%2C%20sophisticated%20textile%20commercial%20style&width=400&height=500&seq=gucci-fabric-shirt-2&orientation=portrait',
        description: 'Camisa Gucci 1.2 – linha italiana premium com detalhes exclusivos.',
        prices: {
          single: 'R$ 95',
          three: 'R$ 85',
          six: 'R$ 75',
          twelve: 'R$ 65',
          wholesale: 'R$ 55'
        }
      },
      {
        id: 3,
        name: 'Camisa Louis Vuitton',
        brand: 'Louis Vuitton',
        line: 'Premium',
        code: 'LV003',
        image: 'https://readdy.ai/api/search-image?query=luxury%20navy%20blue%20Louis%20Vuitton%20shirt%20on%20stylish%20tattooed%20male%20model%2C%20premium%20French%20cotton%20fabric%20texture%20details%2C%20sophisticated%20studio%20lighting%20with%20textile%20focus%2C%20minimalist%20white%20background%2C%20high-end%20fashion%20photography%2C%20professional%20fabric%20commercial%20shoot%20style&width=400&height=500&seq=lv-fabric-shirt-3&orientation=portrait',
        description: 'Camisa Louis Vuitton Premium – qualidade francesa com acabamento perfeito.',
        prices: {
          single: 'R$ 99',
          three: 'R$ 89',
          six: 'R$ 79',
          twelve: 'R$ 69',
          wholesale: 'R$ 59'
        }
      }
    ],
    bermudas: [
      {
        id: 4,
        name: 'Bermuda Versace Sport',
        brand: 'Versace',
        line: '1.1',
        code: 'VER004',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Versace%20shorts%20on%20athletic%20tattooed%20male%20model%2C%20premium%20sport%20fabric%20texture%20visible%2C%20dynamic%20studio%20lighting%20with%20textile%20detail%20focus%2C%20clean%20white%20background%2C%20high-end%20sportswear%20photography%20with%20fabric%20emphasis%2C%20professional%20commercial%20style&width=400&height=500&seq=versace-fabric-shorts-4&orientation=portrait',
        description: 'Bermuda Versace 1.1 – tecido esportivo premium com design italiano.',
        prices: {
          single: 'R$ 79',
          three: 'R$ 69',
          six: 'R$ 59',
          twelve: 'R$ 49',
          wholesale: 'R$ 39'
        }
      }
    ],
    conjuntos: [
      {
        id: 5,
        name: 'Conjunto Armani Complete',
        brand: 'Armani',
        line: 'Premium',
        code: 'ARM005',
        image: 'https://readdy.ai/api/search-image?query=luxury%20gray%20Armani%20complete%20outfit%20set%20on%20elegant%20tattooed%20male%20model%2C%20premium%20Italian%20fabric%20ensemble%20with%20textile%20texture%20details%2C%20sophisticated%20studio%20lighting%20with%20fabric%20focus%2C%20minimalist%20white%20background%2C%20high-end%20fashion%20photography%2C%20professional%20fabric%20commercial%20shoot&width=400&height=500&seq=armani-fabric-set-5&orientation=portrait',
        description: 'Conjunto Armani Premium – camisa e calça em tecido italiano premium.',
        prices: {
          single: 'R$ 189',
          three: 'R$ 169',
          six: 'R$ 149',
          twelve: 'R$ 129',
          wholesale: 'R$ 109'
        }
      }
    ],
    relogios: [
      {
        id: 6,
        name: 'Relógio Rolex Submariner',
        brand: 'Rolex',
        line: '1.1',
        code: 'ROL006',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Rolex%20Submariner%20watch%20on%20tattooed%20male%20wrist%2C%20premium%20metal%20finish%20with%20fabric%20cuff%20detail%2C%20elegant%20studio%20lighting%20with%20textile%20background%2C%20clean%20white%20background%20with%20subtle%20fabric%20reflections%2C%20high-end%20watch%20photography%2C%20professional%20commercial%20style&width=400&height=500&seq=rolex-fabric-watch-6&orientation=portrait',
        description: 'Relógio Rolex Submariner 1.1 – movimento automático com acabamento suíço.',
        prices: {
          single: 'R$ 299',
          three: 'R$ 279',
          six: 'R$ 259',
          twelve: 'R$ 239',
          wholesale: 'R$ 219'
        }
      }
    ],
    bags: [
      {
        id: 7,
        name: 'Bag Louis Vuitton Keepall',
        brand: 'Louis Vuitton',
        line: '1.2',
        code: 'LVB007',
        image: 'https://readdy.ai/api/search-image?query=luxury%20brown%20Louis%20Vuitton%20Keepall%20bag%20held%20by%20tattooed%20male%20model%2C%20premium%20leather%20texture%20with%20fabric%20interior%20details%2C%20sophisticated%20studio%20lighting%20with%20textile%20focus%2C%20minimalist%20white%20background%2C%20high-end%20accessories%20photography%2C%20professional%20fabric%20commercial%20shoot&width=400&height=500&seq=lv-fabric-bag-7&orientation=portrait',
        description: 'Bag Louis Vuitton Keepall 1.2 – couro premium com monograma clássico.',
        prices: {
          single: 'R$ 199',
          three: 'R$ 179',
          six: 'R$ 159',
          twelve: 'R$ 139',
          wholesale: 'R$ 119'
        }
      }
    ],
    acessorios: [
      {
        id: 8,
        name: 'Óculos Ray-Ban Aviator',
        brand: 'Ray-Ban',
        line: 'Premium',
        code: 'RAY008',
        image: 'https://readdy.ai/api/search-image?query=luxury%20gold%20Ray-Ban%20Aviator%20sunglasses%20on%20stylish%20tattooed%20male%20model%2C%20premium%20metal%20frame%20with%20fabric%20clothing%20texture%20background%2C%20sophisticated%20studio%20lighting%20with%20textile%20details%2C%20clean%20white%20background%2C%20high-end%20eyewear%20photography%2C%20professional%20fabric%20commercial%20style&width=400&height=500&seq=rayban-fabric-glasses-8&orientation=portrait',
        description: 'Óculos Ray-Ban Aviator Premium – lentes polarizadas com armação dourada.',
        prices: {
          single: 'R$ 149',
          three: 'R$ 129',
          six: 'R$ 109',
          twelve: 'R$ 89',
          wholesale: 'R$ 69'
        }
      }
    ]
  };

  const handleWhatsApp = (productName: string) => {
    const message = `Olá! Tenho interesse no produto: ${productName}`;
    window.open(`https://wa.me/5511999999999?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleVideoRequest = (productName: string) => {
    const message = `Olá! Gostaria de ver o vídeo HD do produto: ${productName}`;
    window.open(`https://wa.me/5511999999999?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-emerald-100">
      {/* Header */}
      <header className="bg-gradient-to-r from-emerald-800 to-emerald-900 text-white py-8">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                Catalog DLUX
              </h1>
              <p className="text-emerald-200 text-lg mt-2">Luxury For Real Men</p>
              <p className="text-emerald-300 text-sm">Edição 2025</p>
            </div>
            <div className="text-right">
              <div className="bg-white p-4 rounded-lg">
                <div className="w-20 h-20 bg-emerald-800 rounded flex items-center justify-center">
                  <i className="ri-qr-code-line text-white text-2xl"></i>
                </div>
                <p className="text-emerald-800 text-xs mt-2">@dlux_men_</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-center space-x-8 py-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category.id
                    ? 'bg-emerald-600 text-white'
                    : 'text-emerald-700 hover:bg-emerald-100'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span className="font-medium">{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* Products Grid */}
      <main className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products[activeCategory as keyof typeof products]?.map((product) => (
            <div key={product.id} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
              <div className="relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-80 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {product.line}
                </div>
              </div>
              
              <div className="p-6">
                <div className="mb-4">
                  <h3 className="text-xl font-bold text-gray-800 mb-1">{product.name}</h3>
                  <p className="text-emerald-600 font-medium">{product.brand}</p>
                  <p className="text-gray-500 text-sm">Código: {product.code}</p>
                </div>

                <p className="text-gray-600 text-sm mb-4">{product.description}</p>

                {/* Price Table */}
                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Tabela de Preços</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span>1 peça:</span>
                      <span className="font-medium text-emerald-600">{product.prices.single}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>3+ peças:</span>
                      <span className="font-medium text-emerald-600">{product.prices.three}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>6+ peças:</span>
                      <span className="font-medium text-emerald-600">{product.prices.six}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>12+ peças:</span>
                      <span className="font-medium text-emerald-600">{product.prices.twelve}</span>
                    </div>
                    <div className="flex justify-between border-t pt-2">
                      <span className="font-medium">Atacado 20+:</span>
                      <span className="font-bold text-emerald-700">{product.prices.wholesale}</span>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="space-y-3">
                  <button
                    onClick={() => handleWhatsApp(product.name)}
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-3 px-4 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    <span>Chamar no WhatsApp</span>
                  </button>
                  
                  <button
                    onClick={() => handleVideoRequest(product.name)}
                    className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-3 px-4 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-video-line text-lg"></i>
                    <span>Pedir vídeo HD</span>
                  </button>
                  
                  <button
                    onClick={() => window.open('https://instagram.com/dlux_men_', '_blank')}
                    className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-3 px-4 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-instagram-line text-lg"></i>
                    <span>Ver no Instagram</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* About Section */}
      <section className="bg-emerald-800 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Sobre a DLUX</h2>
            <p className="text-emerald-100 text-lg mb-8">
              Luxo real, acessível e de alta rotatividade. A DLUX é referência nacional em clones 1.1 / 1.2, 
              oferecendo produtos de qualidade premium com atendimento personalizado.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-2xl"></i>
                </div>
                <h3 className="font-semibold mb-2">Envio Rápido</h3>
                <p className="text-emerald-200 text-sm">Entrega expressa em todo Brasil</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-video-line text-2xl"></i>
                </div>
                <h3 className="font-semibold mb-2">Vídeos HD</h3>
                <p className="text-emerald-200 text-sm">Veja cada peça em alta definição</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-graduation-cap-line text-2xl"></i>
                </div>
                <h3 className="font-semibold mb-2">Mentoria Gratuita</h3>
                <p className="text-emerald-200 text-sm">Aprenda estratégias de vendas</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-line text-2xl"></i>
                </div>
                <h3 className="font-semibold mb-2">Atendimento VIP</h3>
                <p className="text-emerald-200 text-sm">Suporte personalizado 24/7</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* New Arrivals */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">🔥 Lançamentos - Edição Limitada</h2>
            <p className="text-gray-600">Chegaram agora! Peças exclusivas com qualidade premium</p>
          </div>
          
          <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-2xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Novidades Toda Semana</h3>
            <p className="text-emerald-100 mb-6">
              Acompanhe nossos lançamentos e seja o primeiro a ter acesso às peças mais exclusivas do mercado.
            </p>
            <button
              onClick={() => window.open('https://wa.me/5511999999999?text=Quero%20saber%20sobre%20os%20lan%C3%A7amentos', '_blank')}
              className="bg-white text-emerald-700 px-8 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Receber Novidades
            </button>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">Contato &amp; Suporte</h2>
            
            <div className="bg-gray-800 rounded-lg p-8 text-center">
              <h3 className="text-xl font-semibold mb-4">Loja Física</h3>
              <p className="text-gray-300 mb-2">📍 Rua Monsenhor Andrade, 987 - Brás, São Paulo - SP</p>
              <p className="text-gray-300 mb-2">CEP: 03009-100</p>
              <p className="text-gray-300 mb-2">Corredor Principal Box L 1136 - 1º Andar</p>
              <p className="text-gray-300 mb-2">Feira da Madrugada</p>
              <p className="text-gray-300 mb-4">🕒 Segunda a Sábado: 8h às 15h50</p>
              <p className="text-emerald-400 font-medium">
                💡 Separações via chamada de vídeo — escolha seu estilo em tempo real
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-8">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <h3 className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                Catalog DLUX
              </h3>
              <p className="text-gray-400">© 2025 - Todos os direitos reservados</p>
            </div>
            
            <div className="flex items-center space-x-6">
              <button
                onClick={() => window.open('https://instagram.com/dlux_men_', '_blank')}
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-2xl"></i>
              </button>
              <button
                onClick={() => window.open('https://wa.me/5511999999999', '_blank')}
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
              </button>
              <Link 
                to="https://readdy.ai/?origin=logo"
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Website Builder
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CatalogPage;
